import { PressProps, usePress } from "@react-aria/interactions";
import React from "react";
import { twMerge } from "tailwind-merge";

interface PressableProps extends PressProps {
  children: React.ReactNode;
  className?: string;
}

export function Pressable({ children, className, ...props }: PressableProps) {
  let { pressProps } = usePress(props);
  return (
    <div
      {...pressProps}
      className={twMerge(
        "cursor-pointer outline-none transition-colors duration-base ease-out data-[pressed]:brightness-95 dark:data-[pressed]:brightness-110 data-focus-visible:outline-2 data-focus-visible:outline-offset-2 data-focus-visible:outline-borderFocus",
        className,
      )}>
      {children}
    </div>
  );
}
